export default "__VITE_ASSET__CUIyKmAw__"